import api from '../../utils/api';
import constants from '../constants';
import MoveInFeedbackListing from '../../models/MoveInFeedbackListing';
import map from 'lodash/map';

const MoveInFeedbackActions = {
  // fetch listings back 60 days with renter id
  getListingsByRenterId(renterId, latestInquiredDateInMillis) {
    if (renterId && latestInquiredDateInMillis) {
      return (dispatch) => {
        return dispatch(api.moveInFeedback.getListingsByRenterId(renterId, latestInquiredDateInMillis)).then(
          (response) => {
            if (response.listings) {
              const list = map(response.listings, (listing) => MoveInFeedbackListing(listing));
              return list;
            }
            return;
          },
        );
      };
    } else {
      return Promise.resolve({ success: false });
    }
  },
  // set the listings in -60 days user contacted, fetched from renter-info
  setListings(listings) {
    return (dispatch) => {
      dispatch({
        type: constants.EDIT_LISTINGS,
        payload: listings,
      });
    };
  },
  submitFeedback(payload = {}) {
    return (dispatch) => {
      return dispatch(api.moveInFeedback.submitFeedback(payload));
    };
  },
};

export default MoveInFeedbackActions;
